import React, { useState } from 'react';
import styled from '@emotion/styled';

const templatesForCompany = [
    {
        title: '手数料体系について聞く',
        text: '着手金、中間報酬、成功報酬などの手数料について教えてください。また、手数料計算基準（総資産レーマン、株価レーマンなど）について詳しく教えてください。自社の場合、おおよそどれくらいの手数料となる可能性があるのか教えてください。',
    },
    {
        title: '専任契約か非専任かについて聞く',
        text: 'M&Aを進める場合、専任契約、非専任契約どちらですすめることになりますか。また、専任契約と非専任契約のメリット・デメリットについて教えてください。',
    },
    {
        title: '実際の買い手候補の提案数と属性について聞く',
        text: '自社がM&Aを検討した場合、どのような買い手が想定されるのかマッチングのアイデアなどについて教えてください。また、M&A後の買い手企業とのトラブルを防ぐために行っていることなどがありましたら教えてください。',
    },
    {
        title: '成約までの平均期間と過去実績について聞く',
        text: 'M&Aに要する期間について、貴社がサポートした場合の平均期間などを教えてください。また、自社と同業他社事例など実際に手掛けられたエピソードを教えてください。',
    },
    {
        title: '契約解除時のペナルティや費用について聞く',
        text: '貴社と契約を締結した後にM&Aの検討を取りやめたい場合、契約解除を行った場合のペナルティや解約金の有無について教えてください。',
    },
    {
        title: '担当者について聞く',
        text: '貴社内の担当者の経歴や、どのような人材がサポートしてくれるのか担当者について教えてください。',
    },
    {
        title: '売却希望価格と評価額のギャップについて聞く',
        text: '売却希望金額があるのですが、実際の評価額と乖離があった場合のアドバイスを教えてください。',
    },
    {
        title: '秘密保持・情報管理体制について聞く',
        text: 'M&Aについて、他の人に知られたくないのですが秘密保持契約や貴社内での情報管理体制について教えてください。',
    },
    {
        title: '税務・法務・PMIまで含めた支援体制があるかについて聞く',
        text: 'M&Aに際しての税務サポート、法務サポートや、M&A実施後の貴社の支援体制・サービスについて教えてください。',
    },
];

const templatesForBuyer = [
    {
        title: 'M&Aに関する手数料について聞く',
        text: 'M&Aに関する着手金、中間報酬、成功報酬などの費用について教えてください。提案案件により変動がある場合、計算方法などについても教えてください。また、各手数料の返還可否についても教えてください。',
    },
    {
        title: '提案案件の契約状況について聞く',
        text: 'ご提案いただく案件が、貴社専任案件であるか、すでに貴社にて受託済み案件であるのかなど教えてください。',
    },
    {
        title: '具体的な流れについて聞く',
        text: '貴社提案に興味を持った場合、今後の具体的な流れ（貴社との契約の有無など）について教えてください。',
    },
    {
        title: '想定する事業シナジー、事業展望、スキーム等について聞く',
        text: 'M&Aを進めるにあたり貴社の描く弊社と案件の事業シナジーや展望、スキーム等について教えてください。',
    },
    {
        title: '支援体制、サポート内容について聞く',
        text: 'M&Aに際しての税務サポート、法務サポートや、M&A実施後の記者の支援体制・サービスについて教えてください。',
    },
    {
        title: '担当者について聞く',
        text: '貴社内の担当者の経歴や、どのような人材がサポートしてくれるのか担当者について教えてください。',
    },
    {
        title: '秘密保持・情報管理体制について聞く',
        text: 'M&Aについて、他の人に知られたくないのですが秘密保持契約や貴社内での情報管理体制について教えてください。',
    },
];

const ModalContainer = styled.div`
    background: #fff;
    border-radius: 12px;
    max-width: 700px;
    box-sizing: border-box;
    margin: 0 auto;
`;

const Title = styled.h2`
    font-size: 1.2rem;
    font-weight: bold;
    margin-bottom: 18px;
    text-align: center;
`;

const Description = styled.p`
    font-size: 0.95rem;
    color: #363636;
    text-align: center;
    margin-bottom: 18px;
    margin-top: -8px;
`;

const List = styled.ul`
    list-style: none;
    padding: 0;
    margin: 0;
`;

const ListItem = styled.li`
    margin-bottom: 12px;
`;

const TemplateButton = styled.button`
    width: 100%;
    background: var(--lightblue);
    border: 1px solid var(--main-color-blue);
    border-radius: 6px;
    padding: 12px 10px;
    font-size: 1rem;
    text-align: left;
    cursor: pointer;
    transition: background 0.2s, color 0.2s;
    color: var(--main-color-blue);
    font-weight: 500;
    word-break: break-word;
    white-space: pre-line;
    &:hover {
        background: var(--main-color-blue);
        color: #fff;
    }
`;

const ContentBox = styled.div`
    background: #f7f7f7;
    border-radius: 8px;
    padding: 16px;
    margin: 18px 0 10px 0;
    color: #363636;
    font-size: 1rem;
    white-space: pre-line;
    word-break: break-word;
`;

const ReflectButton = styled.button`
    display: block;
    margin: 0 auto;
    background: var(--main-color-blue);
    color: #fff;
    border: none;
    border-radius: 6px;
    padding: 10px 24px;
    font-size: 0.8rem;
    font-weight: 600;
    cursor: pointer;
    transition: opacity 0.2s;
    &:hover {
        opacity: 0.85;
    }
`;

const AccordionContent = styled.div<{ open: boolean }>`
    overflow: hidden;
    max-height: ${({ open }) => (open ? '500px' : '0')};
    opacity: ${({ open }) => (open ? 1 : 0)};
    transition: max-height 0.6s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.6s;
`;

interface Props {
    onSelect: (text: string) => void;
    onClose: () => void;
    companyType: 'company' | 'buyer' | 'supporter';
}

export const TemplateModal: React.FC<Props> = ({ onSelect, onClose, companyType }) => {
    const [selected, setSelected] = useState<number | null>(null);
    const templates = companyType === 'company' ? templatesForCompany : templatesForBuyer;
    return (
        <ModalContainer>
            <Title>質問テンプレートを選択</Title>
            <Description>選択するとテンプレート本文が表示されます。内容を確認して反映してください。</Description>
            <List>
                {templates.map((tpl, idx) => (
                    <ListItem key={tpl.title}>
                        <TemplateButton
                            onClick={() => setSelected(selected === idx ? null : idx)}
                            style={
                                selected === idx
                                    ? { background: '#e3f2fd', borderColor: '#1976d2', color: '#1976d2' }
                                    : {}
                            }
                        >
                            {tpl.title}
                        </TemplateButton>
                        <AccordionContent open={selected === idx}>
                            {selected === idx && (
                                <>
                                    <ContentBox>{tpl.text}</ContentBox>
                                    <ReflectButton
                                        onClick={() => {
                                            onSelect(tpl.text);
                                            onClose();
                                        }}
                                    >
                                        この内容をメッセージ欄に反映
                                    </ReflectButton>
                                </>
                            )}
                        </AccordionContent>
                    </ListItem>
                ))}
            </List>
        </ModalContainer>
    );
};
